// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import util from '@/util/'
import Element from 'element-ui'
import '@/assets/element-variables.scss'
import '@/pages/common/Header'
import '@/pages/common/MyUpload'
import '@/pages/common/SelectCategory'//供应商分类
//import '@/pages/common/Footer' //todo: see the header

Vue.use(Element);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    if (util.isPublicRoute(to.name)) {//判断是否是不需要登录就可以访问的路由
        next()
    } else {
        if ( !window.sessionStorage.getItem('regenerate_token_flag')) {
            next();
        } else {
            if(this.isPopDialog) return;//如果为true，就不弹了
            Vue.prototype.$alert('登录超时，请重新登录！', {
                callback: action => {
                    this.isPopDialog = true;
                    // let currentUrl = (window.location.href).split('?')[0];
                    next({
                        // path: '/login/'+encodeURIComponent(currentUrl),
                        path: '/login/masterCenter',
                        query: { redirect: to.fullPath }
                    })
                }
            })
        }
    }
});

Vue.prototype.$http = axios.create({
    baseURL: util.baseUrl
});
Vue.prototype.$http.interceptors.request.use( config => {//前端请求
    // 在发送请求之前做些什么，比如设置token
   /* config.data = JSON.stringify(config.data);
    config.headers = {
        // 'Content-Type':'application/x-www-form-urlencoded'
        'Content-Type':'application/json'
    };*/
    config.headers.token = window.sessionStorage.getItem('token') || '';
    config.headers.refresh_token = window.sessionStorage.getItem('refresh_token') || '';
    config.headers.realIp = returnCitySN["cip"] || '';
    // console.log('config',config)
    return config;
}, error => {
    // 对请求错误做些什么
    return Promise.reject(error);
});
Vue.prototype.$http.interceptors.response.use(res => {// 后台响应
    //if(!util.isPublicRoute(app.$route.name) && ~res.data.message.indexOf('未登录')){
    //    app.$router.push(`/login?msg=${res.data.message}&redirect=${app.$route.fullPath}`)
    //}window.sessionStorage.getItem('regenerate_token_flag')
    // console.log('响应',res,res.headers.regenerate_token_flag)
    //  regenerate_token_flag 值为1，可以刷新免登录，重新赋值token，值为2，需要重新登录
    // console.log('token',res,res.headers)
    if(!res.headers ){
        return res;
    }
    if( res.headers.token && res.headers.regenerate_token_flag != 2){
        window.sessionStorage.setItem('token',res.headers.token );
        this.isLogin = true;
    }
    if(res.headers.refresh_token && res.headers.regenerate_token_flag != 2){
        window.sessionStorage.setItem('refresh_token',res.headers.refresh_token );
        this.isLogin = true;
    }
    if(res.headers.regenerate_token_flag == 2){
        window.sessionStorage.setItem('token','');
        window.sessionStorage.setItem('refresh_token','');
        this.isLogin = false;
    }
    return res;
}, error => {
    // alert('加载失败')
    // console.log('失效',error)
   /* window.sessionStorage.setItem('token','');
    window.sessionStorage.setItem('refresh_token','');
    this.isLogin = false;*/
    return Promise.reject(error);
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    data: {
        activeIndex: 'home',
        isLogin: false,//判断是否是登录状态，可以通过$root.isLogin 来获取或者修改；
        uploadUrl: '', //上传接口ipa地址
        downloadUrl: '', //下载接口ipa地址
        baseUrl: '',//当前服务器地址；
        loading: false,//请求loading
        isPopDialog: false,//是否可以弹出登录超时的dialog；
        tableHeaderStyle:{
            'background-color':'#ececec',
            'text-align':'center'
        },
        tableCellStyle:{
            'text-align':'center'
        },
        pageSizesArr:[10,20,50,100,200],
        pickerOptions: {//日期时间控件的选项
            disabledDate(time) {
                // console.log(6789,time)
                //return time.getTime() < Date.now() - 8.64e7;
                return null
            },
        },
        treeProps: {
            children: 'children',
            label: 'categoryName',
            disabled: function (data, node){
                return data.categoryLevel != 3;
            },
        },
    },
    methods: {
        /*上传附件单位转换
        * 按照大小来转换，1M一下用kb，1G一下用MB，1G以上用G
        */
        formatFileSize(size){
            let filesize = parseFloat(size);
            if(filesize >= 1 * 1024 * 1024){
                filesize = (filesize / (1024 * 1024)).toFixed(2) + "G";
            }else if(filesize >= 1 * 1024){
                filesize = (filesize / (1024)).toFixed(2) + "MB";
            }else{
                filesize = filesize.toFixed(2) + "KB";
            }

            let sizestr = filesize + "";
            let len = sizestr.indexOf("\.");
            let dec = sizestr.substr(len + 1, 2);
            if(dec == "00"){//当小数点后为00时 去掉小数部分
                return sizestr.substring(0,len) + sizestr.substr(len + 3,2);
            }
            return sizestr;

        },
        /*get或者post请求封装方法*/
        getHttp(url,successCallback,errorCallback){
            let that = this;
            that.loading = true;
            if(url.indexOf('?') == -1){
                url = url + '?timestamp=' + new Date().getTime();
            }else{
                url = url + '&timestamp=' + new Date().getTime();
            }
            that.$http.get(url,{
                cache: false,
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache'
            }).then(res => {
                that.loading = false;
                // console.log('success,get',res)
                if(res.data.code == '1'){
                    !!successCallback && successCallback(res);
                }else{
                    // console.log('get',url)
                    that.$alert(res.data.msg,{
                        type: 'error',
                        callback: action => {
                            !!errorCallback && errorCallback();
                        }
                    });
                }
            }).catch(function (err) {//401,登录超时
                // console.log('catch,get',err,url);
                that.loading = false;
                if(err.response && err.response.status == '401'){
                    // console.log('get',that.isPopDialog)
                    if(that.isPopDialog) return;//如果为true，就不弹了
                    that.$alert('登录超时，请重新登录',{
                        type: 'error',
                        callback: action => {
                            that.isPopDialog = true;
                            window.sessionStorage.clear();
                            that.$router.push('/login/MasterCenter');
                            /*let currentUrl = (window.location.href).split('?')[0];
                            that.$router.push('/login/'+encodeURIComponent(currentUrl));*/
                        }
                    })
                } else {
                    that.$alert('请求异常'+err,{
                        type: 'error'
                    })
                }
                return;
            })
        },
        postHttp(url,data,successCallback,errorCallback){
            let that = this;
            that.loading = true;
           /* {
                'Content-Type':'application/json'
            }*/
            that.$http.post(url,data,{
                'Content-Type':'application/json'
            }).then(res => {
                that.loading = false;
                if(res.data.code == 1){
                    // console.log('success',res)
                    !!successCallback && successCallback(res);
                }else{
                    console.log('error',url)
                    that.$alert(res.data.msg,{
                        type: 'error',
                        callback: action => {
                            !!errorCallback && errorCallback();
                        }
                    });
                }
            }).catch(function (err) {
               // console.log('post,catch',err)
                that.loading = false;
                if(err.response && err.response.status == '401'){
                    // console.log('post',that.isPopDialog)
                    if(that.isPopDialog) return;//如果为true，就不弹了
                    that.$alert('登录超时，请重新登录',{
                        type: 'error',
                        callback: action => {
                            that.isPopDialog = true;
                            window.sessionStorage.clear();
                            that.$router.push('/login/MasterCenter');
                           /* let currentUrl = (window.location.href).split('?')[0];
                            that.$router.push('/login/'+encodeURIComponent(currentUrl));*/
                        }
                    })
                } else {
                    that.$alert('请求异常'+err,{
                        type: 'error'
                    })
                }
                return;
            })
        },
        
        /*数组去重*/
        uniqueArr(arr){
            let newArr = [];
            for(let i=0; i<arr.length; i++){
                if(newArr.indexOf(arr[i]) == -1){
                    newArr.push(arr[i]);
                }
            }
            return newArr;
        },
        /*两个数组合并去重*/
        concatArr(arr1,arr2){
            //不要直接使用var arr = arr1，这样arr只是arr1的一个引用，两者的修改会互相影响
            var arr = arr1.concat();
            //或者使用slice()复制，var arr = arr1.slice(0)
            for(var i=0;i< arr2.length;i++){
                arr.indexOf(arr2[i]) === -1 ? arr.push(arr2[i]) : 0;
            }
            return arr;
        },
        /*下载文件*/
        downloadFile(formData){
            // let url = util.baseUrl+'/v1/public/file/download?path='+formData.attachPath+'&name='+formData.attachName;
            let url = util.baseUrl+'/v1/public/file/download?filePath='+formData.attachPath+'&oldFileName='+encodeURIComponent(formData.attachName);
            // console.log('url',url)
            window.location.href= url;
            // window.open(url,'_blank');
        },
        showReqLoading(msg = '加载中...', options = {
            lock: true,
            text: msg,
            spinner: 'el-icon-loading',
        }){
            return this.$loading({
                ...options,
                text: msg
            });
        },
        /**
         * 批量打包下载
         * @param {*} formData 
         * @param {*} fileName 
         */
        batchDownloadFile(formData, fileName, callBack){
            let url = `/v1/public/file/multiDownload`;
            const loadingObj = this.showReqLoading('正在下载...');
            this.$http.post(url,formData,{
                'Content-Type':'application/json',
                // responseType:'arraybuffer' //此处注意请求头
                responseType:'blob' //此处注意请求头
            }).then(res => {
                this.fileBufferDownload(res.data, fileName)
                callBack && callBack();
            }).catch((err) => {
               this.$alert("下载失败", {
                   type: 'warning'
               })
            }).finally(() => {
                loadingObj.close();
            })
        },
        /**
         * 文件流下载
         */
        fileBufferDownload(data, fileName) {
　　　　　　if (!data) {
                this.$alert("下载失败", {
                    type: 'warning'
                })
　　　　　　　　  return;
　　　　　　}
　　　　　　let url = window.URL.createObjectURL(new Blob([data])); //创建下载链接
　　　　　　let link = document.createElement('a'); //创建a标签
　　　　　　link.style.display = 'none';  //将a标签隐藏
　　　　　　link.href = url;  //给a标签添加下载链接
　　　　　　link.setAttribute('download', fileName); // 此处注意，要给a标签添加一个download属性，属性值就是文件名称 否则下载出来的文件是没有属性的，空白白
　　　　　　document.body.appendChild(link);
　　　　　　link.click();  //执行a标签
　　　　 },
        handleSelect(index){
            // console.log(index);
            this.activeIndex = index
        },
        getCityCompanyData(fn){
           axios.post(this.baseUrl+'/v1/mtCompanyMiddle/public/listAllCompany',{}).then((res) => {
               // console.log(res)
               if(res.data.code == 1){
                  !!fn && fn(res);
               }
           })
        },
        toThousands(num) {
            var result = '', counter = 0;
            num = (num || 0).toString();
            for (var i = num.length - 1; i >= 0; i--) {
                counter++;
                result = num.charAt(i) + result;
                if (!(counter % 3) && i != 0) { result = ',' + result; }
            }
            return result;
        },
    },
    created(){
        this.uploadUrl = util.uploadUrl;
        this.downloadUrl = util.downloadUrl;
        this.baseUrl = util.baseUrl;
        this.isLogin = window.sessionStorage.getItem('token') ? true : false;
    }
});



// WEBPACK FOOTER //
// ./src/main.js